import { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { MfaPolicyGate } from "@/components/MfaPolicyGate";
import InstitutionLayout from "@/layouts/InstitutionLayout";

const InstitutionDashboard = lazy(() => import("@/pages/institution/InstitutionDashboard"));
const FacilityHubPage = lazy(() => import("@/pages/institution/FacilityHubPage"));
const InstitutionAppointmentsPage = lazy(() => import("@/pages/institution/InstitutionAppointmentsPage"));
const InstitutionAutoSchedulingPage = lazy(() => import("@/pages/institution/InstitutionAutoSchedulingPage"));
const CareManagementPage = lazy(() => import("@/pages/institution/CareManagementPage"));
const SickCallInfirmaryPage = lazy(() => import("@/pages/institution/SickCallInfirmaryPage"));
const EMARPage = lazy(() => import("@/pages/institution/eMARPage"));
const IntakeQueuePage = lazy(() => import("@/pages/institution/IntakeQueuePage"));
const ReceivingScreenPage = lazy(() => import("@/pages/institution/ReceivingScreenPage"));
const HealthAssessmentPage = lazy(() => import("@/pages/institution/HealthAssessmentPage"));
const WithdrawalToolPage = lazy(() => import("@/pages/institution/WithdrawalToolPage"));
const IntakeReportPage = lazy(() => import("@/pages/institution/IntakeReportPage"));
const ChronicCarePage = lazy(() => import("@/pages/institution/ChronicCarePage"));
const WithdrawalMonitoringPage = lazy(() => import("@/pages/institution/WithdrawalMonitoringPage"));
const ChronicRegistryPage = lazy(() => import("@/pages/institution/ChronicRegistryPage"));
const WatchPage = lazy(() => import("@/pages/institution/WatchPage"));
const SrNotePage = lazy(() => import("@/pages/institution/SrNotePage"));
const KeepSeparatePage = lazy(() => import("@/pages/institution/KeepSeparatePage"));
const PageOnCallPage = lazy(() => import("@/pages/institution/PageOnCallPage"));
const InmateDetailPage = lazy(() => import("@/pages/institution/InmateDetailPage"));
const InmateCrisisProfile = lazy(() => import("@/pages/institution/InmateCrisisProfile"));
const RiskAssessmentPage = lazy(() => import("@/pages/institution/RiskAssessmentPage"));
const RecidivismRiskPage = lazy(() => import("@/pages/institution/RecidivismRiskPage"));
const FacilityReportPage = lazy(() => import("@/pages/institution/FacilityReportPage"));
const AppEngagementPage = lazy(() => import("@/pages/institution/AppEngagementPage"));
const MetricsPage = lazy(() => import("@/pages/institution/MetricsPage"));
const PreReleasePage = lazy(() => import("@/pages/institution/PreReleasePage"));
const MedicaidPage = lazy(() => import("@/pages/institution/MedicaidPage"));
const BulkEnrollPage = lazy(() => import("@/pages/institution/BulkEnrollPage"));
const CareRequestsPage = lazy(() => import("@/pages/institution/CareRequestsPage"));
const PlanContractPage = lazy(() => import("@/pages/institution/PlanContractPage"));
const ReportsPage = lazy(() => import("@/pages/institution/ReportsPage"));
const ReportsHubPage = lazy(() => import("@/pages/institution/ReportsHubPage"));
const EmergencyMeasuresReportPage = lazy(() => import("@/pages/institution/EmergencyMeasuresReportPage"));

const DentalPage = lazy(() => import("@/pages/institution/DentalPage"));
const SchedulingWorklistPage = lazy(() => import("@/pages/institution/SchedulingWorklistPage"));
const DietPage = lazy(() => import("@/pages/institution/DietPage"));
const DisciplinaryHearingsPage = lazy(() => import("@/pages/institution/DisciplinaryHearingsPage"));
const CourtTodayPage = lazy(() => import("@/pages/institution/CourtTodayPage"));
const MortalityReviewPage = lazy(() => import("@/pages/institution/MortalityReviewPage"));

const InfectionControlPage = lazy(() => import("@/pages/institution/InfectionControlPage"));
const ADAAccommodationsPage = lazy(() => import("@/pages/institution/ADAAccommodationsPage"));
const ADAManagementPage = lazy(() => import("@/pages/institution/ADAManagementPage"));
const MedicationSafetyPage = lazy(() => import("@/pages/institution/MedicationSafetyPage"));
const ClinicalIncidentsPage = lazy(() => import("@/pages/institution/ClinicalIncidentsPage"));
const OccupancyPage = lazy(() => import("@/pages/institution/OccupancyPage"));
const OutOfFacilityCarePage = lazy(() => import("@/pages/institution/OutOfFacilityCarePage"));
const RefusalRegisterPage = lazy(() => import("@/pages/institution/RefusalRegisterPage"));
const WomensHealthPage = lazy(() => import("@/pages/institution/WomensHealthPage"));
const InstitutionSettingsPage = lazy(() => import("@/pages/institution/InstitutionSettingsPage"));
const PharmacyLabsPage = lazy(() => import("@/pages/institution/PharmacyLabsPage"));
const ClinicalStaffPage = lazy(() => import("@/pages/institution/ClinicalStaffPage"));
const CorrectionalStaffPage = lazy(() => import("@/pages/institution/CorrectionalStaffPage"));
const InstitutionStandingOrdersPage = lazy(() => import("@/pages/institution/InstitutionStandingOrdersPage"));
const InstitutionBillingPage = lazy(() => import("@/pages/institution/InstitutionBillingPage"));
const FacilitySuperbillPage = lazy(() => import("@/pages/institution/FacilitySuperbillPage"));
const MessagesPage = lazy(() => import("@/pages/MessagesPage"));
const SecurityPage = lazy(() => import("@/pages/SecurityPage"));
const GrievancesPage = lazy(() => import("@/pages/institution/GrievanceCoordinatorPage"));
const PreaCompliancePage = lazy(() => import("@/pages/institution/PreaCompliancePage"));
const OversightIntakesPage = lazy(() => import("@/pages/institution/OversightIntakesPage"));
const OversightBookingReleasePage = lazy(() => import("@/pages/institution/OversightBookingReleasePage"));
const StgRosterPage = lazy(() => import("@/pages/institution/StgRosterPage"));
const UnclaimedPropertyPage = lazy(() => import("@/pages/institution/UnclaimedPropertyPage"));
const StateReportingPage = lazy(() => import("@/pages/institution/StateReportingPage"));
const OversightClinicalTurnaroundPage = lazy(() => import("@/pages/institution/OversightClinicalTurnaroundPage"));
const CustodyReportsRegisterPage = lazy(() => import("@/pages/institution/CustodyReportsRegisterPage"));
const CapTrackerPage = lazy(() => import("@/pages/institution/CapTrackerPage"));
const PharmacistInspectionPage = lazy(() => import("@/pages/institution/PharmacistInspectionPage"));
const UseOfForcePage = lazy(() => import("@/pages/institution/UseOfForcePage"));
const IncidentReportsPage = lazy(() => import("@/pages/institution/IncidentReportsPage"));
const MATPage = lazy(() => import("@/pages/institution/MATPage"));
const FacilityRecordRequestsPage = lazy(() => import("@/pages/institution/FacilityRecordRequestsPage"));
const CustodyRoundsPage = lazy(() => import("@/pages/institution/CustodyRoundsPage"));
const QuickRoundPage = lazy(() => import("@/pages/institution/QuickRoundPage"));
const TierRoundPage = lazy(() => import("@/pages/institution/TierRoundPage"));
const CustodyDashboardPage = lazy(() => import("@/pages/institution/CustodyDashboardPage"));
const CustodyLogPage = lazy(() => import("@/pages/institution/CustodyLogPage"));
const MealRefusalPage = lazy(() => import("@/pages/institution/MealRefusalPage"));
const ShiftHandoffPage = lazy(() => import("@/pages/institution/ShiftHandoffPage"));
const ShiftHandoffLogPage = lazy(() => import("@/pages/institution/ShiftHandoffLogPage"));
const CustodyHubPage = lazy(() => import("@/pages/institution/CustodyHubPage"));
const ClinicalAlertsPage = lazy(() => import("@/pages/institution/ClinicalAlertsPage"));
const ContrabandPage = lazy(() => import("@/pages/institution/ContrabandPage"));

export function InstitutionRoutes() {
    return (
        <Route
            path="/institution"
            element={
                <ProtectedRoute roles={["institution", "institution_admin"]}>
                    <MfaPolicyGate><InstitutionLayout /></MfaPolicyGate>
                </ProtectedRoute>
            }
        >
            <Route index element={<FacilityHubPage />} />
            <Route path="appointments" element={<InstitutionAppointmentsPage />} />
            <Route path="auto-scheduling" element={<InstitutionAutoSchedulingPage />} />
            <Route path="crisis-dashboard" element={<InstitutionDashboard />} />
            <Route path="care-management" element={<CareManagementPage />} />
            <Route path="clinical-queue" element={<SickCallInfirmaryPage />} />
            <Route path="sick-call" element={<SickCallInfirmaryPage defaultTab="sick-call" />} />
            <Route path="emar" element={<EMARPage />} />
            <Route path="chronic" element={<ChronicCarePage />} />
            <Route path="withdrawal-monitoring" element={<WithdrawalMonitoringPage />} />
            <Route path="oversight/intakes" element={<OversightIntakesPage />} />
            <Route path="oversight/booking-release" element={<OversightBookingReleasePage />} />
            <Route path="oversight/stg-roster" element={<StgRosterPage />} />
            <Route path="oversight/unclaimed-property" element={<UnclaimedPropertyPage />} />
            <Route path="reports/state-reporting" element={<StateReportingPage />} />
            <Route path="oversight/clinical-queues" element={<OversightClinicalTurnaroundPage />} />
            <Route path="oversight/reports" element={<CustodyReportsRegisterPage />} />
            <Route path="cap-tracker" element={<CapTrackerPage />} />
            <Route path="pharmacist-inspections" element={<PharmacistInspectionPage />} />
            <Route path="chronic/:key" element={<ChronicRegistryPage />} />
            <Route path="watch" element={<Navigate to="/institution?tab=custody&ctab=rounds" replace />} />
            <Route path="watch/:watchId" element={<WatchPage />} />
            <Route path="sr-note/:watchId" element={<SrNotePage />} />
            <Route path="keep-separate" element={<KeepSeparatePage />} />

            <Route path="page-oncall" element={<PageOnCallPage />} />
            <Route path="grievances" element={<GrievancesPage />} />
            <Route path="prea-compliance" element={<PreaCompliancePage />} />
            <Route path="use-of-force" element={<UseOfForcePage />} />
            <Route path="incidents" element={<IncidentReportsPage />} />
            <Route path="mat" element={<MATPage />} />
            <Route path="intake" element={<IntakeQueuePage />} />
            <Route path="intake/report" element={<IntakeReportPage />} />
            <Route path="intake/:inmateId/screen" element={<ReceivingScreenPage />} />
            <Route path="intake/:inmateId/appraisal" element={<HealthAssessmentPage />} />
            <Route path="intake/:inmateId/withdrawal" element={<WithdrawalToolPage />} />
            <Route path="infirmary" element={<SickCallInfirmaryPage defaultTab="infirmary" />} />
            <Route path="access-codes" element={<Navigate to="/institution" replace />} />
            <Route path="crisis-alerts" element={<Navigate to="/institution/crisis-dashboard" replace />} />
            <Route path="inmates" element={<Navigate to="/institution" replace />} />
            <Route path="inmates/:inmateId/crisis-profile" element={<InmateCrisisProfile />} />
            <Route path="inmates/:id" element={<InmateDetailPage />} />
            <Route path="risk-assessment" element={<RiskAssessmentPage />} />
            <Route path="recidivism" element={<RecidivismRiskPage />} />
            <Route path="facility-report" element={<FacilityReportPage />} />
            <Route path="app-engagement" element={<AppEngagementPage />} />
            <Route path="metrics" element={<MetricsPage />} />
            <Route path="pre-release" element={<PreReleasePage />} />
            <Route path="medicaid" element={<MedicaidPage />} />
            <Route path="bulk-enroll" element={<BulkEnrollPage />} />
            <Route path="billing" element={<InstitutionBillingPage />} />
            <Route path="superbill" element={<FacilitySuperbillPage />} />
            <Route path="care-requests" element={<CareRequestsPage />} />
            <Route path="record-requests" element={<FacilityRecordRequestsPage />} />
            <Route path="custody" element={<CustodyHubPage />} />
            <Route path="custody-board" element={<CustodyDashboardPage />} />
            <Route path="custody/log" element={<CustodyLogPage />} />
            <Route path="custody/rounds" element={<CustodyRoundsPage />} />
            <Route path="custody/quick-round" element={<QuickRoundPage />} />
            <Route path="custody/tier-round" element={<TierRoundPage />} />
            <Route path="custody/meals" element={<MealRefusalPage />} />
            <Route path="custody/handoff" element={<ShiftHandoffPage />} />
            <Route path="shift-handoff" element={<ShiftHandoffLogPage />} />
            <Route path="custody/contraband" element={<ContrabandPage />} />
            <Route path="clinical-alerts" element={<ClinicalAlertsPage />} />
            <Route path="plan" element={<PlanContractPage />} />
            <Route path="reports" element={<ReportsHubPage />} />
            <Route path="reports/emergency-measures" element={<EmergencyMeasuresReportPage />} />
            <Route path="dental" element={<DentalPage />} />
            <Route path="scheduling-worklist" element={<SchedulingWorklistPage />} />
            <Route path="diet" element={<DietPage />} />
            <Route path="disciplinary" element={<DisciplinaryHearingsPage />} />
            <Route path="court" element={<CourtTodayPage />} />
            <Route path="mortality" element={<MortalityReviewPage />} />
            <Route path="infection-control" element={<InfectionControlPage />} />
            <Route path="ada-accommodations" element={<ADAAccommodationsPage />} />
            <Route path="ada-management" element={<ADAManagementPage />} />
            <Route path="med-safety" element={<MedicationSafetyPage />} />
            <Route path="clinical-incidents" element={<ClinicalIncidentsPage />} />
            <Route path="occupancy" element={<OccupancyPage />} />
            <Route path="offsite-care" element={<OutOfFacilityCarePage />} />
            <Route path="refusals" element={<RefusalRegisterPage />} />
            <Route path="womens-health" element={<WomensHealthPage />} />
            <Route path="pharmacies-labs" element={<PharmacyLabsPage />} />
            <Route path="clinical-staff" element={<ClinicalStaffPage />} />
            <Route path="correctional-staff" element={<CorrectionalStaffPage />} />
            <Route path="standing-orders" element={<InstitutionStandingOrdersPage />} />
            <Route path="settings" element={<InstitutionSettingsPage />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="security" element={<SecurityPage />} />
        </Route>
    );
}
